import { FuturesMiniController } from "./futures-mini.controller";

const futuresMiniBlockComponent = {
	bindings: {},
	template: require("./external-futures-mini.html"),
	controller: FuturesMiniController,
	controllerAs: "fc",
};

export default futuresMiniBlockComponent;